import { PerformDocumentActionModalData } from '@components/modals/performDocumentActionModal/PerformDocumentActionModal';

const usePerformDocumentActionModalEventHandlers = () => {
    return {
        onClose: (modalData: PerformDocumentActionModalData) => {
            const { onCanceled } = modalData;

            if (onCanceled) {
                onCanceled();
            }
        },
    };
};

export default usePerformDocumentActionModalEventHandlers;
